// ── Individual / per-user plans ───────────────────────────────────────────
// ── Group / multi-company plans ───────────────────────────────────────────
//
// idIN: the plan ID to send to the backend for India (INR) users.
//       When absent the base `id` is used (e.g. FREE has no INR variant).
// section: "individual" | "group"  — used to split the pricing grid.

const PLANS = [
  // ── Individual ────────────────────────────────────────────────────────────
  {
    id: "FREE",
    section: "individual",
    name: "Free",
    badge: "No Credit Card Required",
    description: "For quickly creating and signing forms and agreements.",
    priceMonthly: 0,
    priceAnnual: 0,
    priceMonthlyIN: 0,
    priceAnnualIN: 0,
    cta: { label: "Get started for free", variant: "outline" },
    features: [
      "Send and sign up to 3 envelopes per month.",
      "Access 2 reusable document templates.",
      "Secure, cloud-based document storage.",
      "Two-factor identity authentication.",
      "24/7 email and chat support.",
    ],
  },
  {
    id: "STANDARD",
    idIN: "STANDARD_IN",
    section: "individual",
    name: "Standard",
    description: "For individuals that need to send and sign documents.",
    priceMonthly: 10,
    priceAnnual: 7,
    priceMonthlyIN: 499,
    priceAnnualIN: 349,
    cta: { label: "Buy Now", variant: "outline" },
    features: [
      "Up to 3 team members.",
      "Send up to 30 envelopes per month.",
      "Unlimited reusable document templates.",
      "Automatic reminders and notifications.",
      "Bulk send to multiple recipients.",
      "24/7 email and chat support.",
    ],
  },
  {
    id: "BUSINESS",
    idIN: "BUSINESS_IN",
    section: "individual",
    name: "Business",
    highlight: true,
    ribbon: "MOST POPULAR",
    description:
      "For small to medium teams that need to send and track multiple documents.",
    priceMonthly: 15,
    priceAnnual: 10.5,
    priceMonthlyIN: 999,
    priceAnnualIN: 699,
    cta: { label: "Buy Now", variant: "primary" },
    features: [
      "One plan covers up to 5 team members.",
      "Unlimited templates and unlimited envelopes per month.",
      "Template sharing across your team.",
      "Role-based access control.",
      "OTP verification for document signing.",
      "24/7 priority support.",
    ],
  },
  {
    id: "BUSINESS_PRO",
    section: "individual",
    name: "Business Pro",
    description:
      "For large enterprises seeking flexible limits and priority support.",
    priceMonthly: null,
    priceAnnual: null,
    priceMonthlyIN: null,
    priceAnnualIN: null,
    cta: { label: "Contact Sales", variant: "outline" },
    contact: true,
    features: [
      "Custom user and envelope limits.",
      "OTP verification for document signing.",
      "Dedicated account manager.",
      "Round-the-clock priority support.",
    ],
  },

  // ── Group / Multi-Company ─────────────────────────────────────────────────
  {
    id: "GROUP_STARTER",
    idIN: "GROUP_STARTER_IN",
    section: "group",
    name: "Group Starter",
    description:
      "For growing businesses managing up to 3 companies under one organization.",
    priceMonthly: 45,
    priceAnnual: 40,
    priceMonthlyIN: 1500,
    priceAnnualIN: 900,
    cta: { label: "Buy Now", variant: "outline" },
    features: [
      "Up to 3 companies in one organization.",
      "Unlimited users across all companies.",
      "Unlimited templates.",
      "300 shared sign requests/month.",
      "Bulk send, OTP verification, sequential signing.",
      "Role-based access control.",
    ],
  },
  {
    id: "GROUP_PRO",
    idIN: "GROUP_PRO_IN",
    section: "group",
    name: "Group Pro",
    highlight: true,
    ribbon: "BEST VALUE",
    description:
      "For organizations managing up to 10 companies with high-volume needs.",
    priceMonthly: 100,
    priceAnnual: 90,
    priceMonthlyIN: 3000,
    priceAnnualIN: 2700,
    cta: { label: "Buy Now", variant: "primary" },
    features: [
      "Up to 10 companies in one organization.",
      "Unlimited users across all companies.",
      "Unlimited templates.",
      "1,200 shared sign requests/month.",
      "All Group Starter features.",
      "Dedicated support.",
    ],
  },
  {
    id: "ENTERPRISE_HOLDING",
    section: "group",
    name: "Enterprise",
    description:
      "For holding companies and enterprises that need unlimited companies and custom limits.",
    priceMonthly: null,
    priceAnnual: null,
    priceMonthlyIN: null,
    priceAnnualIN: null,
    cta: { label: "Contact Sales", variant: "outline" },
    contact: true,
    features: [
      "Unlimited companies under one organization.",
      "Custom sign request pool.",
      "Custom user and template limits.",
      "Dedicated account manager.",
      "SLA-backed priority support.",
    ],
  },
];

export default PLANS;
